if (!customElements.get('cloud-hero')) {
  customElements.define(
    'cloud-hero',
    class CloudHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-cloud-hero-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-cloud-hero-dot]'));
        this.index = Math.max(
          0,
          this.slides.findIndex((slide) => slide.classList.contains('is-active')),
        );

        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true)));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        document.addEventListener('visibilitychange', this.handleVisibility);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.handleVisibility);
      }

      handleVisibility = () => {
        if (document.hidden) this.stop();
        else this.start();
      };

      show(index, restart = false) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          const video = slide.querySelector('video');
          if (video) {
            if (active) video.play().catch(() => {});
            else video.pause();
          }
        });
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (restart) {
          this.stop();
          this.start();
        }
      }

      start() {
        if (this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stop();
        const seconds = Number(this.dataset.autoplaySeconds) || 5;
        this.timer = window.setInterval(() => this.show(this.index + 1), seconds * 1000);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = undefined;
      }
    },
  );
}
